
import clsBaseGlobal from './base'
import feature from '@app/features'

const arrFillable = [
    "show_info_duedate",
    "show_info_relation_vat",
    "show_info_project_nr",
    "show_info_project_ref",
    "show_info_reference",
    "show_info_relation_nr",
    "show_col_heading",
    "show_col_count",
    "show_col_unit",
    "show_col_unitprice",
    "show_col_discount",
    "show_col_vat",
    "line_total_price",
    "footer_invoice",
    "footer_credit_invoice",
    "footer_g_account",
    "footer_incasso_invoice",
    "email_copy",
    "email_copy_send",
    "payment_duedays",
    "next_number",
    "send_ubl",
    "use_bookdate",
    "use_consumer_prices",
    "incl_excl_vat",
    "footer_align",
    "use_custom_footer",
    "specify_vat_shifted",
    "defaults",

];


class clsGlobalSalesInvoice extends clsBaseGlobal {

    // From company settings edit
    show_info_duedate      = null
    show_info_relation_vat = null
    show_info_project_nr   = null
    show_info_project_ref  = null
    show_info_reference    = null
    show_info_relation_nr  = null
    show_col_heading       = null
    show_col_count         = null
    show_col_unit          = null
    show_col_unitprice     = null
    show_col_discount      = null
    show_col_vat           = null
    line_total_price       = null
    footer_invoice         = null
    footer_credit_invoice  = null
    footer_incasso_invoice = null
    footer_g_account       = null
    email_copy             = null
    email_copy_send        = null
    payment_duedays        = null
    next_number            = null
    send_ubl               = null
    use_bookdate           = null
    use_consumer_prices    = false
    incl_excl_vat          = null
    footer_align           = null
    use_custom_footer      = null
    specify_vat_shifted    = false
    defaults               = {};

    get fillable() { return arrFillable; }

    fill(data) {
        data = data ||{};
        if (!feature.canProject) {
            data.show_info_project_ref  = false;
            data.show_info_project_nr  = false;
        }
        data.show_info_duedate                = !!data.show_info_duedate;
        data.show_info_relation_vat           = !!data.show_info_relation_vat;
        data.show_info_project_nr             = !!data.show_info_project_nr;
        data.show_info_project_ref            = !!data.show_info_project_ref;
        data.show_info_reference              = !!data.show_info_reference;
        data.show_info_relation_nr            = !!data.show_info_relation_nr;
        data.show_col_heading                 = !!data.show_col_heading;
        data.show_col_count                   = !!data.show_col_count;
        data.show_col_unit                    = !!data.show_col_unit;
        data.show_col_unitprice               = !!data.show_col_unitprice;
        data.show_col_discount                = !!data.show_col_discount;
        data.show_col_vat                     = !!data.show_col_vat;
        data.email_copy_send                  = !!data.email_copy_send;
        data.send_ubl                         = !!data.send_ubl;
        data.use_bookdate                     = !!data.use_bookdate;
        data.line_total_price                 = data.line_total_price || "auto"
        data.use_consumer_prices              = !!data.use_consumer_prices
        data.use_custom_footer                = !!data.use_custom_footer;
        data.specify_vat_shifted              = !!data.specify_vat_shifted;
        data.defaults                         = data.defaults;

        return super.fill(data);
    }
}

export default clsGlobalSalesInvoice;